import { motion } from "framer-motion";
import { Github, Linkedin, Mail } from "lucide-react";
import { SiX } from "react-icons/si";

export default function SocialLinks() {
  return (
    <div className="p-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="flex justify-center gap-6"
      >
        <a 
          href="https://github.com/jonassiebler" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="GitHub"
        >
          <Github size={24} />
        </a>
        <a 
          href="https://www.linkedin.com/in/jonas-siebler-3aba9220a" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="LinkedIn"
        >
          <Linkedin size={24} />
        </a>
        <a 
          href="https://x.com/JonasSiebler" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="X (Twitter)"
        >
          <SiX size={24} />
        </a>
        <a 
          href="mailto:jonas@kuehmel.de" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="Email"
        >
          <Mail size={24} />
        </a>
      </motion.div>
    </div>
  );
}
